import { useEffect, useState } from "react";
import { useDetailContext } from "../DetailContext"
import { EventCallbackParamsType, MockupObject } from "../MockupEditor";
import CustomImage from "components/common/CustomImage";
import { useMockupsContext } from "pages/project/mockups/MockupsContext";
import Stats from "libs/utils/stats";


/**
 * 特定操作之后的提示(每个project都需显示一次)
 */
export default function UploadedTips(){
    const detailContext = useDetailContext();
    const [ isStartShow, setIsStartShow ] = useState<boolean>(false);
    const [ isLoadMockup, setIsLoadMockup ] = useState<boolean>(false);
    const [ step, setStep ]= useState<number>(-1);


    const finishStep = () => {
        let key = 'TIPS-';
        if(isLoadMockup){
            key += 'M-';
        }
        key += step ;
        localStorage.setItem(key, JSON.stringify({
            count: 3,
            expire : new Date().getTime()
        }));
        setIsStartShow(false);
    }

    useEffect(() => {
        if(!localStorage.getItem('FIRST')){
            Stats.google('First_visit');
            localStorage.setItem('FIRST','1')
        }
    }, [ ])
    
    useEffect(() => {  
        const type = detailContext?.editorCallbackData?.type ;
        const data = detailContext?.editorCallbackData?.data as MockupObject ;
        let _step = -1, delay = 0, _isLoadMockup = false;
        switch(type){
            case EventCallbackParamsType.ADD_ELEMENT_SUC_CALLBACK: // 添加图像成功
                _step = 0 ;
                break;
            case EventCallbackParamsType.ACTION_FINISH: // 生成mockup成功
                _step = 1 ;
                break;
            case EventCallbackParamsType.MOCKUP_IMAGE_FINISH: // 直接加载底图成功
                _step = 1 ;
                _isLoadMockup = true ;
                break;
        }

        if(_step >= 0){
            let key = 'TIPS-';
            if(_isLoadMockup){
                key += 'M-';
            }
            key += _step ;

            const tipsData = localStorage.getItem(key);
            let _count = 0 ;
            if(tipsData){
                const tips = JSON.parse(tipsData);
                _count = tips.count ;
                if(_count >= 3){
                    const isPassTime = new Date().getTime() - tips.expire >  48 * 60 * 60 * 1000;
                    if(!isPassTime) return ;
                }
            }

            localStorage.setItem(key, JSON.stringify({
                count: _count + 1,
                expire : new Date().getTime()
            }));

            setIsStartShow(true);
            setStep(_step);
            setIsLoadMockup(_isLoadMockup);
        }

    },[detailContext?.editorCallbackData]);

    return (
        <>
            {
                isStartShow &&
                (
                    step == 0 ? 
                        <div className="absolute z-[9000] left-[270px] xl:left-[420px] top-[50%] translate-y-[-50%] px-[10px] py-[20px] w-[280px] rounded-[10px] bg-[#FFFFFF] text-[#4C4C4C] shadow-box">
                            <CustomImage src="/case/icon-uploaded-tips-0.gif" className="w-full"/>
                            <ol className="list-decimal ml-[15px]" start={1}>
                                <li className="mt-[10px]">Uploading the product image, <span className="text-[#14A5FA]">click the "Mockup" button to generate a mockup</span>.</li>
                            </ol>
                            <p className="mt-[15px]">Note: If the product image is not generated into a mockup, you will not be able to see a realistic preview.</p>
                            <button className="text-[#000000] py-[7px] w-full border border-[#d9d9d9] rounded-[10px] mt-[15px]"
                                onClick={finishStep}>OK</button>
                        </div>
                    : step == 1 ?
                        <div className="absolute z-[9000] left-[270px] xl:left-[420px] top-[50%] translate-y-[-50%] px-[10px] py-[20px] w-[280px] rounded-[10px] bg-[#FFFFFF] text-[#4C4C4C] shadow-box">
                            <CustomImage src="/case/icon-uploaded-tips-1.gif" className="w-full"/>
                            <ol className="list-decimal ml-[15px]" start={2}>
                                <li className="mt-[10px]">Upload your design image and <span className="text-[#14A5FA]">drag it onto the mockup to preview the fitting effect</span>.</li>
                            </ol>
                            <p className="mt-[15px]">Note: If you don't have a design image at the moment, you can create one using our AI text-to-image feature.</p>
                            <button className="text-[#000000] py-[7px] w-full border border-[#d9d9d9] rounded-[10px] mt-[15px]"
                                onClick={finishStep}>OK</button>
                        </div>
                    : step == 2 ?
                        <div className="absolute z-[9000] left-[270px] xl:left-[420px] top-[50%] translate-y-[-50%] px-[10px] py-[20px] w-[280px] rounded-[10px] bg-[#FFFFFF] text-[#4C4C4C] shadow-box">
                            <CustomImage src="/case/icon-uploaded-tips-2.gif" className="w-full"/>
                            <ol className="list-decimal ml-[15px]" start={3}>
                                <li className="mt-[10px]">Select your designed Mockup and <span className="text-[#14A5FA]"> click the Download button for a high quality free download</span>.</li>
                            </ol>
                            <button className="text-[#000000] py-[7px] w-full border border-[#d9d9d9] rounded-[10px] mt-[15px]"
                                onClick={finishStep}>OK</button>
                        </div>
                    : null
                )
                
            }
        </>
    )
}